import { Tag } from "features/shared/types/tag";
import { InfoAdapterType } from "features/shared/types/info";

const getKeyFromFlattenedTag = (
    flattenedTag: Record<string, any>
): Tag["key"] => {
    if (!flattenedTag.tree) return "";
    if (!flattenedTag.subtree_1) return flattenedTag.tree;
    if (!flattenedTag.subtree_2)
        return flattenedTag.tree + ":" + flattenedTag.subtree_1;
    if (!flattenedTag.subtree_3)
        return (
            flattenedTag.tree +
            ":" +
            flattenedTag.subtree_1 +
            ":" +
            flattenedTag.subtree_2
        );
    return (
        flattenedTag.tree +
        ":" +
        flattenedTag.subtree_1 +
        ":" +
        flattenedTag.subtree_2 +
        ":" +
        flattenedTag.subtree_3
    );
};

export const unflattenTag = (flattenedTag: Record<string, any>): Tag => {
    let unflattenedTag: Tag = {
        key: getKeyFromFlattenedTag(flattenedTag),
        value: {
            type: flattenedTag.type,
        },
    };

    switch (unflattenedTag.value.type) {
        case InfoAdapterType.DefaultInfo:
            if (flattenedTag.name_en || flattenedTag.name_th) {
                unflattenedTag.value.name = {
                    en: flattenedTag.name_en || "",
                    th: flattenedTag.name_th || "",
                };
            }
            if (flattenedTag.description_en || flattenedTag.description_th) {
                unflattenedTag.value.description = {
                    en: flattenedTag.description_en || "",
                    th: flattenedTag.description_th || "",
                };
            }

            flattenedTag.image &&
                (unflattenedTag.value.image = flattenedTag.image);
            flattenedTag.seo && (unflattenedTag.value.seo = flattenedTag.seo);
            flattenedTag.rank &&
                (unflattenedTag.value.rank = flattenedTag.rank);
            flattenedTag.viewCount &&
                (unflattenedTag.value.viewCount = flattenedTag.viewCount);
            flattenedTag.linkedArticleId &&
                (unflattenedTag.value.linkedArticleId =
                    flattenedTag.linkedArticleId);
            break;
        case InfoAdapterType.StringInfo:
            flattenedTag.name_en &&
                (unflattenedTag.value.value = flattenedTag.name_en);
    }

    return unflattenedTag;
};

export const flattenTag = (tag: Tag) => {
    switch (tag.value.type) {
        case InfoAdapterType.DefaultInfo:
            return {
                tree: tag.key.split(":")[0],
                subtree_1: tag.key.split(":")[1],
                subtree_2: tag.key.split(":")[2],
                subtree_3: tag.key.split(":")[3],
                type: tag.value.type,
                name_en: tag.value.name?.en,
                name_th: tag.value.name?.th,
                description_en: tag.value.description?.en,
                description_th: tag.value.description?.th,
                image: tag.value.image,
                seo: tag.value.seo,
                rank: tag.value.rank,
                viewCount: tag.value.viewCount,
                linkedArticleId: tag.value.linkedArticleId,
            };
        case InfoAdapterType.StringInfo:
            return {
                key: tag.key,
                type: tag.value.type,
                name_en: tag.value.value,
            };
    }
};
